import { Collapse } from 'antd';
import { useTranslation } from 'react-i18next';
import unloggedFetcher from 'services/unloggedFetcher';
import useSWR from 'swr';
import { useLanguage } from 'contexts/languageContext';
import './styles.scss';

const { Panel } = Collapse;

function FooterFAQ() {
  const { t } = useTranslation();
  const { faqLanguage } = useLanguage();

  const { data } = useSWR(
    `/faq?languageCode=${faqLanguage}&page=-1`,
    unloggedFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    }
  );

  const faqItems = (data?.content || []).slice(0, 5);

  return (
    <div className="footer-faq">
      <div className="footer-faq__container">
        <h3 className="footer-faq__title">
          <span className="orange-text">FAQ </span> - {t('faq.footerTitle')}
        </h3>

        <div className="footer-faq__questions">
          <Collapse defaultActiveKey={[]} expandIconPosition="end">
            {faqItems.map((item) => (
              <Panel header={item.question} key={item.id}>
                <p>{item.answer}</p>
              </Panel>
            ))}
          </Collapse>
        </div>

        <div className="footer-faq__contact">
          <p className="footer-faq__questions-title">
            <span>{t('faq.footerStillHave')} </span>
            <span className="highlight">{t('faq.footerQuestions')}</span>
          </p>
          <p className="footer-faq__contact-email">
            {t('faq.footerReachOut')}{' '}
            <a href={`mailto:${t('faq.contactEmail')}`}>
              {t('faq.contactEmail')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default FooterFAQ;
